<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="600"
    style="z-index: 6"
  >
    <v-form ref="addPrinterForm" @submit.prevent="submit">
      <v-card
        flat
        class="overflow-auto"
        :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown }"
      >
        <div class="modal-header">
          <v-icon color="#00BCD4" size="20" class="mr-2">mdi-printer</v-icon>
          <span class="modal-title">Printer</span>
          <v-spacer></v-spacer>
          <span class="modal-close-btn" @click="close">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
        <v-card-text>
          <v-row class="flex-wrap justify-center">
            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    label="Naziv printera"
                    autofocus
                    v-model="name"
                    class="pt-2 form-input"
                    :rules="[rules.req]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    label="Printer adresa servera"
                    v-model="ipAddress"
                    class="form-input"
                    :rules="[rules.req]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    label="Ime printera na mreži"
                    v-model="printerName"
                    class="form-input"
                    :rules="[rules.req]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-5">
          <v-btn
            text
            class="btn-primary"
            height="45"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            Dodaj printer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { df } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import rules from '@/plugins/rules'
// import state from '@/state'
// import clone from '@/plugins/utils'

export default {
  components: { },
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  data: () => ({
    visible: false,
    location: undefined,
    submitting: false,
    name: undefined,
    ipAddress: undefined,
    printerName: undefined,
    rules: {
      req: rules.req(),
      eq: rules.eq
    },
    listeners: []
  }),
  mounted () {
  },
  methods: {
    open (locationId) {
      this.visible = true
      this.submitting = false
      this.locationId = locationId
    },
    close () {
      this.resetInputs()
    },
    resetInputs () {
      this.name = undefined
      this.ipAddress = undefined
      this.printerName = undefined
      this.visible = false
      this.location = undefined
    },
    async submit () {
      const printerId = uuidv4()
      const docRef = df.doc(`location_printers/${this.locationId}/printers/${printerId}`)

      try {
        await docRef.set(
          {
            id: printerId,
            name: this.name,
            ip_address: this.ipAddress,
            printer_name: this.printerName
          }
        )
        console.log('Printer successfully saved.')
      } catch (err) {
        console.error('Error saving printer: ', err)
      }

      this.resetInputs()
    }
  }

}
</script>
<style scoped>
.modal-header {
  display: flex; align-items: center;
  padding: 22px 24px 16px;
  border-bottom: 1px solid #F1F5F9;
}
.modal-title { font-size: 16px; font-weight: 700; color: #1e293b; }
.modal-close-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 28px; height: 28px;
  border-radius: 8px;
  color: #64748B;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
}
.modal-close-btn:hover { background: #FEE2E2; color: #DC2626; }
.form-input >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F8FAFC !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}
.btn-secondary {
  padding: 11px 20px;
  background: #F8FAFC;
  border: 1.5px solid #E2E8F0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-secondary:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
  color: #334155;
}
</style>
